const APPLICATION_API_PREFIX = '/v1'

export function resolveApplicationApiUrl(baseUrl: string, endpoint: string): string {
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`
  const versionedEndpoint =
    normalizedEndpoint === APPLICATION_API_PREFIX || normalizedEndpoint.startsWith(`${APPLICATION_API_PREFIX}/`)
      ? normalizedEndpoint
      : `${APPLICATION_API_PREFIX}${normalizedEndpoint}`

  return `${baseUrl}${versionedEndpoint}`
}
